module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-outline', {
    attrs: {
      "title": _vm.titleLabel,
      "icon": _vm.titleIcon
    }
  }, [_c('template', {
    slot: "pageContent"
  }, [(!_vm.details.id || (_vm.showOtherDebtors() && _vm.otherRTP.length === 0)) ? _c('spinner') : _c('div', [(_vm.showOtherDebtors() && _vm.otherRTP.length > 1) ? _c('form-accordion', {
    attrs: {
      "title": 'Demandes du groupe'
    }
  }, [_c('transactions-list', {
    attrs: {
      "filterBy": "",
      "itemListStyle": "border-radius:0;",
      "actualMessageId": _vm.details.id,
      "messages": _vm.otherRTP,
      "randomId": _vm.randomId,
      "serviceId": _vm.services.PAYMENTS
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showOtherDebtors() && _vm.otherRTP.length > 1) ? _c('hr') : _vm._e(), _vm._v(" "), _c('form-accordion', {
    attrs: {
      "title": _vm.$t('common.request_details')
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.rsn'),
      "inputValue": _vm.details.reason
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.status.status_label'),
      "inputValue": _vm.getStatusLabel(_vm.details.status, _vm.details.negotStatus),
      "statusIcon": _vm.getStatusIcon(_vm.details.status, _vm.details.negotStatus)
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [(_vm.details.direction === '0') ? [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.crdtr_name'),
      "inputValue": _vm.details.creditorName
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.crdtr_mail'),
      "inputValue": _vm.details.creditorIdentifier
    }
  })], 1)] : (_vm.details.direction === '1' && !_vm.isDebtorAnon) ? [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.debtor_name'),
      "inputValue": _vm.details.debtorName
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.debtor_email'),
      "inputValue": _vm.details.debtorIdentifier
    }
  })], 1)] : [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.debtor_name'),
      "inputValue": _vm.$t('requestToPay.anon_debtor')
    }
  })], 1)]], 2), _vm._v(" "), _c('b-row', [(!_vm.isDebtorAnon) ? _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('label', {
    staticClass: "createInvoiceBandlabelAccordionForm"
  }, [_vm._v("\n              " + _vm._s(_vm.details.direction === '1' ? _vm.$t('common.debtor_ibn') : _vm.$t('common.my_ibn')) + "\n            ")]), _vm._v(" "), (_vm.details.acceptModifyBankAccount === '0' ||
    (_vm.details.direction === '1' && _vm.paymentMethod === 'application') ||
    (_vm.details.direction === '0' && !_vm.waitingForAnswerRTP(_vm.details.status))) ? _c('div', {
    staticClass: "labelAccordionForm"
  }, [(_vm.details.debtorAccountResponse.length > 0) ? _c('input', {
    staticClass: "form-control inputAccordionForm",
    attrs: {
      "type": "text",
      "disabled": "true"
    },
    domProps: {
      "value": _vm.hideIban(_vm.details.debtorAccountResponse)
    }
  }) : (_vm.details.debtorBankAccount.length > 0) ? _c('input', {
    staticClass: "form-control inputAccordionForm",
    attrs: {
      "type": "text",
      "disabled": "true"
    },
    domProps: {
      "value": _vm.hideIban(_vm.details.debtorBankAccount)
    }
  }) : (_vm.details.debtorBankAccount.length === 0) ? _c('span', [_vm._v("Not\n                specified")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.details.acceptModifyBankAccount === '1' && _vm.details.direction === '0' && _vm.waitingForAnswerRTP(_vm.details.status)) ? _c('div', {
    staticClass: "labelAccordionForm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bankAccountSelectDebit),
      expression: "bankAccountSelectDebit"
    }],
    staticClass: "form-control inputAccordionForm",
    class: {
      redBackground: _vm.bankAccountSelectDebit === ''
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.bankAccountSelectDebit)
    },
    on: {
      "focus": _vm.showBankAccountSelectionList,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bankAccountSelectDebit = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.showIbanBox) ? _c('b-col', {
    ref: "ibanBox",
    staticClass: "bankAccountDebitSelectionListContainer"
  }, [_c('div', {
    staticClass: "closeSelectionListContainerLabel",
    on: {
      "click": _vm.closeSelectionListContainer
    }
  }, [_c('div', {
    staticClass: "closeSelectionListContainerLabelName"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('bank_accounts.my_accounts')) + "\n                  ")]), _vm._v(" "), _c('f7-button', {
    staticClass: "orangeBackground rightButton",
    staticStyle: {
      "padding": "0px 3px"
    },
    attrs: {
      "round": ""
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('common.close_label')) + "\n                  ")])], 1), _vm._v(" "), (_vm.bankAccounts.length > 0) ? _c('ul', {
    staticClass: "bankAccountDebitSelectionList"
  }, _vm._l((_vm.bankAccounts), function(bankAccount) {
    return _c('li', {
      key: bankAccount.iban,
      staticClass: "bankAccountDebitSelectionListItem",
      attrs: {
        "data-iban": bankAccount.iban
      },
      on: {
        "click": function($event) {
          return _vm.selectBankAccount($event)
        }
      }
    }, [_c('div', [_vm._v(_vm._s(bankAccount.iban))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(bankAccount.name))])])
  }), 0) : _c('ul', {
    staticClass: "bankAccountDebitSelectionList"
  }, [_c('li', {
    staticClass: "bankAccountDebitSelectionListItem"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("No bank account")])])])]) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.details.debtorAccountResponse.length > 0 && _vm.details.debtorAccountResponse !== _vm.details.debtorBankAccount) ? _c('div', [_c('b-row', {
    staticClass: "form-group"
  }, [_c('b-col', {
    staticClass: "transactionDetailSubHeader"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('common.orig_terms')) + "\n              ")])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.before_label'),
      "inputValue": _vm.hideIban(_vm.details.debtorBankAccount)
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.details.direction === '0' ? _vm.$t('common.crdt_ibn') : _vm.$t('common.my_ibn'),
      "inputValue": _vm.hideIban(_vm.details.creditorBankAccount)
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.rqst_date'),
      "inputValue": _vm._f("formatDate")(_vm.details.creationDate)
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.end_to_end_id'),
      "inputValue": _vm.details.endToEndId
    }
  })], 1)], 1), _vm._v(" "), (_vm.waitingForAnswerRTP(_vm.details.status)) ? _c('b-row', [(_vm.details.direction === '0' && _vm.details.acceptModifyAmount === '1') ? _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "isMandatory": "",
      "inputType": "number",
      "idLabel": _vm.$t('common.amnt'),
      "placeholderValue": _vm.$t('common.amnt')
    },
    model: {
      value: (_vm.details.amount),
      callback: function($$v) {
        _vm.$set(_vm.details, "amount", $$v)
      },
      expression: "details.amount"
    }
  })], 1) : _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.amnt'),
      "inputValue": _vm.details.amount + ' ' + _vm.getCurrencyIcon(_vm.details.currency)
    }
  })], 1), _vm._v(" "), (_vm.details.direction === '0' && _vm.details.acceptModifyExecutionDate === '1') ? _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "isMandatory": "",
      "inputType": "date",
      "disablePastDates": "",
      "disableFromDate": _vm.oldDate,
      "idLabel": _vm.$t('common.exec_date')
    },
    model: {
      value: (_vm.details.requestedExecutionDate),
      callback: function($$v) {
        _vm.$set(_vm.details, "requestedExecutionDate", $$v)
      },
      expression: "details.requestedExecutionDate"
    }
  })], 1) : _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.exec_date'),
      "inputValue": _vm._f("formatDate")(_vm.details.requestedExecutionDate)
    }
  })], 1)], 1) : _c('b-row', [(_vm.details.amountResponse.length > 0) ? _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.amnt'),
      "inputValue": _vm.details.amountResponse + ' ' + _vm.getCurrencyIcon(_vm.details.currency)
    }
  })], 1) : _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.amnt'),
      "inputValue": _vm.details.amount + ' ' + _vm.getCurrencyIcon(_vm.details.currency)
    }
  })], 1), _vm._v(" "), (_vm.details.executionDateResponse.length > 0) ? _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.exec_date'),
      "inputValue": _vm._f("formatDate")(_vm.details.executionDateResponse)
    }
  })], 1) : _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.exec_date'),
      "inputValue": _vm._f("formatDate")(_vm.details.requestedExecutionDate)
    }
  })], 1)], 1), _vm._v(" "), (_vm.details.direction === '0') ? _c('b-row', [_c('b-col', {
    staticClass: "form-group"
  }, [(_vm.showInstantPayment(_vm.details.debtorBankAccount)) ? _c('b-form-checkbox', {
    staticClass: "mt-sm-2",
    attrs: {
      "value": "1",
      "unchecked-value": "0",
      "disabled": !_vm.waitingForAnswerRTP(_vm.details.status) || _vm.isInstantPayment
    },
    model: {
      value: (_vm.details.instantPayment),
      callback: function($$v) {
        _vm.$set(_vm.details, "instantPayment", $$v)
      },
      expression: "details.instantPayment"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('requestToPay.is_inst_payment')) + "\n              " + _vm._s('(' + _vm.getBankName(_vm.details.debtorBankAccount) + ')') + "\n            ")]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), ((_vm.waitingForAnswerRTP(_vm.details.status) && _vm.details.negotStatus === '10') ||
    (_vm.waitingForAnswerRTP(_vm.details.status) && _vm.details.negotStatus === '11') ||
    _vm.details.status === _vm.status.ACCEPTED ||
    _vm.details.status === _vm.status.MODIFIED ||
    _vm.details.status === _vm.status.REVOKED ||
    _vm.details.status === _vm.status.ACCEPTED_AND_PAYED ||
    _vm.details.status === _vm.status.ACCEPTED_AND_PAYED_INST ||
    _vm.details.status === _vm.status.MODIFIED_AND_PAYED ||
    _vm.details.status === _vm.status.MODIFIED_AND_PAYED_INST ||
    _vm.details.status === _vm.status.ORDER_GENERATED ||
    _vm.details.status === _vm.status.MADE ||
    _vm.details.status === _vm.status.INST_MADE) ? _c('div', [(((_vm.details.amountResponse.length > 0 && _vm.details.amountResponse !== _vm.details.amount) ||
    (_vm.details.executionDateResponse.length > 0 && _vm.details.requestedExecutionDate !== _vm.details.executionDateResponse))) ? _c('div', [_c('b-row', {
    staticClass: "form-group"
  }, [_c('b-col', {
    staticClass: "transactionDetailSubHeader"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('common.orig_terms')) + "\n              ")])], 1), _vm._v(" "), _c('b-row', [(_vm.details.amountResponse.length > 0 && _vm.details.amountResponse !== _vm.details.amount) ? _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.orig_amount'),
      "inputValue": _vm.details.amount + ' ' + _vm.getCurrencyIcon(_vm.details.currency)
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.details.executionDateResponse.length > 0 && _vm.details.requestedExecutionDate !== _vm.details.executionDateResponse) ? _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.exec_date_orig'),
      "inputValue": _vm._f("formatDate")(_vm.details.requestedExecutionDate)
    }
  })], 1) : _vm._e()], 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.details.hasPmtResp === '1' && _vm.details.pmtResp.multPmts.length > 0) ? _c('b-col', {
    staticClass: "form-group pl-sm-0",
    attrs: {
      "sm": "6"
    }
  }, [_c('label', {
    staticClass: "createInvoiceBand"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('common.pymnts_annoucement', {
    install_number: _vm.details.pmtResp.multPmts.length
  })) + "\n          ")]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-bordered table-installment"
  }, [_c('thead', {
    staticClass: "thead-dark"
  }, [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('common.installment_amount')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('common.installment_date')))]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.details.pmtResp.multPmts), function(installment, index) {
    return _c('tr', {
      key: 'installment-' + index
    }, [_c('td', [_vm._v("\n                  " + _vm._s(installment.amount + ' ' + _vm.getCurrencyIcon(installment.currency)) + "\n                ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatDate")(installment.date)))]), _vm._v(" "), _c('td', [_c('span', [(installment.pay === '0' || installment.pay === '1') ? _c('f7-icon', {
      staticClass: "icon-transaction-detail",
      attrs: {
        "icon": "icon-clock_forward"
      }
    }) : (installment.pay === '2') ? _c('f7-icon', {
      staticClass: "icon-transaction-detail",
      attrs: {
        "icon": "icon-receipt"
      }
    }) : _c('f7-icon', {
      staticClass: "icon-transaction-detail",
      attrs: {
        "icon": "icon-made"
      }
    })], 1)])])
  }), 0)])]) : _vm._e(), _vm._v(" "), ((_vm.details.Attachments && _vm.details.Attachments.length > 0) || _vm.details.lettrage) ? _c('b-row', {
    staticClass: "mt-2"
  }, [(_vm.details.lettrage) ? _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "transactionDetailSubHeader",
    attrs: {
      "cols": "12"
    }
  }, [_vm._v("\n                " + _vm._s("Lettrage") + "\n              ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "12"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.details.lettrage && _vm.details.lettrage.length > 0 ? _vm.formatLettrage(_vm.details.lettrage) : 'Pas de lettrage') + "\n              ")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.details.Attachments && _vm.details.Attachments.length > 0) ? _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "transactionDetailSubHeader",
    attrs: {
      "cols": "12"
    }
  }, [_vm._v("\n                " + _vm._s("Document") + "\n              ")])], 1), _vm._v(" "), _vm._l((_vm.details.Attachments), function(attachment) {
    return _c('b-row', {
      key: attachment.AttachmentId
    }, [_c('b-col', {
      staticClass: "form-group",
      attrs: {
        "sm": "4"
      }
    }, [_c('div', {
      staticClass: "d-flex justify-content-between"
    }, [_c('label', {
      attrs: {
        "id": "application-file-input"
      }
    }, [_vm._v("\n                    " + _vm._s(attachment.AttachmentName) + "\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "d-flex"
    }, [_c('i', {
      staticClass: "icon fa fa-download mx-1",
      on: {
        "click": function($event) {
          return _vm.view(attachment.AttachmentId)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "icon fa fa-search mx-1",
      on: {
        "click": function($event) {
          return _vm.openDoc(attachment.AttachmentId)
        }
      }
    })])])])], 1)
  })], 2) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showNegotiation()) ? _c('div', [_c('b-row', {
    staticClass: "form-group"
  }, [_c('b-col', {
    staticClass: "transactionDetailSubHeader"
  }, [_vm._v("\n              Negotiation\n            ")])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.new_amount'),
      "inputValue": _vm.details.pmtNegot.amountDebtor + ' ' + _vm.getCurrencyIcon(_vm.details.ccy)
    }
  })], 1), _vm._v(" "), (_vm.details.pmtNegot.multiPayments.length > 0) ? _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('label', {
    staticClass: "createInvoiceBand"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('common.pymnts_annoucement', {
    install_number: _vm.details.pmtNegot.multiPayments.length
  })) + "\n              ")]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-bordered table-installment"
  }, [_c('thead', {
    staticClass: "thead-dark"
  }, [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('common.installment_amount')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('common.installment_date')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.details.pmtNegot.multiPayments), function(pmt, index) {
    return _c('tr', {
      key: 'pmt-' + index
    }, [_c('td', [_vm._v("\n                      " + _vm._s(pmt.amount + ' ' + _vm.getCurrencyIcon(_vm.details.currency)) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                      " + _vm._s(_vm._f("formatDate")(pmt.date)) + "\n                    ")])])
  }), 0)])]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), ((_vm.details.negotStatus === '12')) ? _c('div', [_c('b-row', {
    staticClass: "form-group"
  }, [_c('b-col', {
    staticClass: "transactionDetailSubHeader"
  }, [_vm._v("\n              Final Terms\n            ")])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.final_amount'),
      "inputValue": _vm.details.pmtResp.dbtAmt !== '' ?
        (_vm.details.pmtResp.dbtAmt + _vm.getCurrencyIcon(_vm.details.currency)) :
        (_vm.details.amount + _vm.getCurrencyIcon(_vm.details.currency))
    }
  })], 1), _vm._v(" "), (_vm.details.pmtResp.multPmts.length > 0) ? _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('label', {
    staticClass: "createInvoiceBand"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('common.pymnts_annoucement', {
    install_number: _vm.details.pmtResp.multPmts.length
  })) + "\n              ")]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-bordered table-installment"
  }, [_c('thead', {
    staticClass: "thead-dark"
  }, [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('common.installment_amount')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('common.installment_date')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.details.pmtResp.multPmts), function(pmt, index) {
    return _c('tr', {
      key: 'pmt-' + index
    }, [_c('td', [_vm._v("\n                      " + _vm._s(pmt.amount + ' ' + _vm.getCurrencyIcon(_vm.details.currency)) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                      " + _vm._s(_vm._f("formatDate")(pmt.date)) + "\n                    ")])])
  }), 0)])]) : _vm._e()], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.details.status === _vm.status.REVOKED) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.details.status === _vm.status.REVOKED) ? _c('form-accordion', {
    attrs: {
      "title": _vm.$t('common.formsSubTitle.refuse_reason')
    }
  }, [_c('b-row', [_c('b-col', [_c('p', [_vm._v(_vm._s(_vm.details.decisionMessage))])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.details.cancelMessage && _vm.details.cancelMessage !== '') ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.details.cancelCode && _vm.details.cancelCode !== '') ? _c('form-accordion', {
    attrs: {
      "title": _vm.$t('common.formsSubTitle.cancel_reason')
    }
  }, [_c('b-row', [_c('b-col', [_c('p', [_c('b', [_vm._v(_vm._s(_vm.$t(_vm.getCancelCodeLabel(_vm.details.cancelCode))))])]), _vm._v(" "), (_vm.details.cancelMessage && _vm.details.cancelMessage !== '') ? _c('p', [_vm._v(_vm._s(_vm.details.cancelMessage))]) : _vm._e()])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.details.direction === '0' && _vm.waitingForAnswerRTP(_vm.details.status) && _vm.details.acceptMultipleInstalments === '1') ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.details.direction === '0' && _vm.waitingForAnswerRTP(_vm.details.status) && _vm.details.acceptMultipleInstalments === '1') ? _c('form-accordion', {
    attrs: {
      "title": 'ECHEANCIER'
    }
  }, [_c('b-row', [_c('b-col', [_c('b-form-checkbox', {
    staticClass: "mt-sm-2",
    attrs: {
      "value": true,
      "unchecked-value": false
    },
    model: {
      value: (_vm.showInstallments),
      callback: function($$v) {
        _vm.showInstallments = $$v
      },
      expression: "showInstallments"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('common.ask_multiple_payments_times')) + "\n            ")])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.showInstallments) ? _c('b-row', [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "inputType": "number",
      "idLabel": "Nombre d'échéances"
    },
    model: {
      value: (_vm.numInstallments),
      callback: function($$v) {
        _vm.numInstallments = $$v
      },
      expression: "numInstallments"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showInstallments) ? _c('b-row', [_c('b-col', [_c('echeancier', {
    attrs: {
      "numPay": _vm.numInstallments,
      "min": 1,
      "amount": _vm.details.amount,
      "ccy": "€",
      "deposit": 0,
      "execDate": _vm.details.requestedExecutionDate
    },
    model: {
      value: (_vm.multPmts),
      callback: function($$v) {
        _vm.multPmts = $$v
      },
      expression: "multPmts"
    }
  })], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('form-accordion', {
    attrs: {
      "title": _vm.$t('common.formsSubTitle.rqst_to_pay_hstry'),
      "open": false
    }
  }, [_c('b-row', {
    staticClass: "form-group"
  }, [_c('b-col', [_c('table', {
    staticClass: "table table-striped table-bordered table-status-history"
  }, [_c('thead', {
    staticClass: "thead-dark"
  }, [_c('tr', [_c('th', {
    staticClass: "reponsiveColumnWidth",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('common.date_label')) + "\n                  ")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('common.status.status_label')) + "\n                  ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.details.history), function(record) {
    return _c('tr', {
      key: record.id
    }, [_c('td', {
      staticClass: "dateTimehistoryHeight"
    }, [_vm._v("\n                    " + _vm._s(_vm._f("formatDateTime")(record.creationDate)) + "\n                  ")]), _vm._v(" "), _c('td', [_c('b-row', [_c('b-col', {
      staticClass: "statusHistoryLabel",
      attrs: {
        "sm": "7"
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.getHistoryLabel(record.status)) + "\n                        "), _c('f7-icon', {
      staticClass: "icon-transaction-detail",
      attrs: {
        "icon": _vm.getHistoryIcon(record.status)
      }
    })], 1), _vm._v(" "), _c('b-col', {
      attrs: {
        "sm": "5"
      }
    }, [(_vm.showPain001View(record)) ? _c('f7-button', {
      staticClass: "xmlButtonBackground",
      on: {
        "click": function($event) {
          return _vm.viewXML()
        }
      }
    }, [_vm._v("\n                          " + _vm._s(_vm.$t('common.button_technical_details')) + "\n                        ")]) : _vm._e()], 1)], 1), _vm._v(" "), ((record.status === '10' || record.status === '11') && record.comment !== '') ? _c('div', {
      staticClass: "item-content"
    }, [_c('div', {
      staticClass: "item-inner",
      staticStyle: {
        "display": "block"
      }
    }, [_c('div', {
      staticClass: "item-title-row",
      staticStyle: {
        "font-style": "italic"
      }
    }, [_vm._v("\n                          " + _vm._s(_vm.$t('common.ngttn_cmmnt')) + ":\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "item-title-row"
    }, [_c('div', {
      staticStyle: {
        "color": "#8e8e93"
      }
    }, [_vm._v("\n                            " + _vm._s(record.comment) + "\n                          ")])])])]) : _vm._e(), _vm._v(" "), _c('div', [((_vm.details.status === '1' || _vm.details.status === '2' || _vm.details.status === '3') &&
      _vm.details.responseComment !== '') ? _c('li', {
      staticClass: "item-content"
    }, [_c('div', {
      staticClass: "item-inner",
      staticStyle: {
        "display": "block"
      }
    }, [_c('div', {
      staticClass: "item-title-row"
    }, [_vm._v("\n                            " + _vm._s(_vm.$t('common.rspns_cmmnt')) + ":\n                          ")]), _vm._v(" "), _c('div', {
      staticClass: "item-title-row"
    }, [_c('div', {
      staticStyle: {
        "color": "#8e8e93"
      }
    }, [_vm._v("\n                              " + _vm._s(_vm.details.responseComment) + "\n                            ")])])])]) : _vm._e()])], 1)])
  }), 0)])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('template', {
    slot: "footerButtons"
  }, [(!_vm.details.id || (_vm.showOtherDebtors() && _vm.otherRTP.length === 0)) ? _c('div') : _c('div', [(_vm.details.direction === '0') ? _c('b-row', {
    staticClass: "inboxDetailButton"
  }, [_c('b-col', {
    attrs: {
      "md": "10",
      "offset-md": "1"
    }
  }, [_c('b-row', {
    staticClass: "justify-content-start"
  }, [(_vm.LMSGsupplierconfig) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [(_vm.waitingForAnswerRTP(_vm.details.status) && _vm.details.pay !== 'none' && !_vm.$engine.user.isOtp) ? _c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    on: {
      "click": function($event) {
        return _vm.showPaymentAxepta()
      }
    }
  }, [_c('f7-icon', {
    attrs: {
      "fa": "check"
    }
  }), _vm._v("\n                " + _vm._s(_vm.$t('common.accpt_nd_pay')) + "\n              ")], 1) : _vm._e(), _vm._v(" "), ((_vm.details.status === _vm.status.ACCEPTED || _vm.details.status === _vm.status.MODIFIED) && _vm.details.pay !== 'none' && !_vm.$engine.user.isOtp) ? _c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    on: {
      "click": function($event) {
        return _vm.showPaymentAxepta()
      }
    }
  }, [_c('f7-icon', {
    attrs: {
      "fa": "check"
    }
  }), _vm._v("\n                " + _vm._s(_vm.$t('common.pay')) + "\n              ")], 1) : _vm._e()], 1) : _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "md": "3"
    }
  }, [(_vm.showButtonAcceptAndPay()) ? _c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    on: {
      "click": function($event) {
        return _vm.transactionAcceptedAndPay()
      }
    }
  }, [_c('f7-icon', {
    attrs: {
      "fa": "check"
    }
  }), _vm._v("\n                " + _vm._s(_vm.$t('common.accpt_nd_pay')) + "\n              ")], 1) : _vm._e(), _vm._v(" "), (_vm.showButtonPay()) ? _c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    on: {
      "click": function($event) {
        return _vm.Pay()
      }
    }
  }, [_c('f7-icon', {
    attrs: {
      "fa": "check"
    }
  }), _vm._v("\n                " + _vm._s(_vm.$t('common.pay')) + "\n              ")], 1) : _vm._e()], 1), _vm._v(" "), (_vm.showButtonAccept()) ? _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "md": "3"
    }
  }, [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    on: {
      "click": function($event) {
        return _vm.transactionAccepted()
      }
    }
  }, [_c('f7-icon', {
    attrs: {
      "fa": "check"
    }
  }), _vm._v("\n                " + _vm._s(_vm.$t('common.accpt')) + "\n              ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showButtonRefuse()) ? _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "md": "3"
    }
  }, [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    on: {
      "click": _vm.transactionRefused
    }
  }, [_c('f7-icon', {
    attrs: {
      "fa": "hand-stop-o"
    }
  }), _vm._v("\n                " + _vm._s(_vm.$t('common.refus')) + "\n              ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showButtonNegotiate()) ? _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "md": "3"
    }
  }, [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    attrs: {
      "href": "/payments/negotiate/"
    }
  }, [_c('f7-icon', {
    attrs: {
      "fa": "repeat"
    }
  }), _vm._v("\n                " + _vm._s(_vm.$t('common.negot')) + "\n              ")], 1)], 1) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.details.direction === '1') ? _c('div', {
    staticClass: "inboxDetailButton"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "10",
      "offset-md": "1"
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "md": "3"
    }
  }, [(_vm.showButtonCancel()) ? _c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    on: {
      "click": function($event) {
        return _vm.cancelRequestToPay(_vm.details.endToEndId)
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('requestToPay.cancel_rtp')) + "\n                ")]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.showButtonAcceptNegotiation()) ? _c('b-row', {
    staticClass: "justify-content-start"
  }, [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "md": "3",
      "offset-md": "1"
    }
  }, [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    on: {
      "click": function($event) {
        return _vm.acceptNegotiation()
      }
    }
  }, [_c('f7-icon', {
    attrs: {
      "fa": "handshake-o"
    }
  }), _vm._v("\n              Accept Negotiation\n            ")], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "md": "4"
    }
  }, [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    attrs: {
      "href": "/payments/negotiate/"
    }
  }, [_c('f7-icon', {
    attrs: {
      "fa": "repeat"
    }
  }), _vm._v("\n              Negotiate\n            ")], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "md": "3"
    }
  }, [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    on: {
      "click": function($event) {
        return _vm.refuseNegotiation()
      }
    }
  }, [_c('f7-icon', {
    attrs: {
      "fa": "hand-stop-o"
    }
  }), _vm._v("\n              Refuse and insist on the original request\n            ")], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.waitingForAnswerRTP(_vm.details.status)) ? _c('b-row', {
    staticClass: "justify-content-start"
  }, [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "md": "3",
      "offset-md": "4"
    }
  }, [(false) ? _c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    on: {
      "click": function($event) {
        return _vm.remindReceiver(_vm.details.id)
      }
    }
  }, [_c('f7-icon', {
    attrs: {
      "fa": "bell"
    }
  }), _vm._v("\n              " + _vm._s(_vm.$t('requestToPay.remind_rcvr')) + "\n            ")], 1) : _vm._e()], 1)], 1) : _vm._e()], 1) : _vm._e()], 1)])], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-33fd9610", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33fd9610","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/requests/detailPages/RequestToPayDetailPage.vue
// module id = 2326
// module chunks = 2